import React, { useEffect, useState } from 'react';
import {
  Routes,
  Route,
  useSearchParams,
  useParams,
  useNavigate,
} from '@leagueplatform/routing';
import {
  isConfigSettled,
  isProduction,
  useConfigSelection,
  getModulePath,
  LEAGUE_MODULE_NAMES,
} from '@leagueplatform/core';
import { JoinTeamPage } from '#pages/join-team-page/join-team-page.page.tsx';
import { SettingsPage } from '#pages/settings-page/settings-page.page.tsx';
import { ChallengeLandingPage } from './pages/challenge-landing-page/challenge-landing-page.page';
import { TeamLandingPage } from './pages/team-landing-page/team-landing-page.page';
import { ChallengeActivitiesHistoryPage } from './pages/challenge-activities-history-page/challenge-activities-history-page';

function ProgramOverviewRedirect() {
  const navigate = useNavigate();

  const { challengeId } = useParams();

  useEffect(() => {
    navigate(
      `${getModulePath(LEAGUE_MODULE_NAMES.challenge)}?id=${challengeId}`,
      { replace: true },
    );
  }, [navigate, challengeId]);

  return null;
}

function useEnableProgramOverviewMasonry() {
  const [isLocallyEnabled, setIsLocallyEnabled] = useState(false);
  const defaultServerConfig = {
    enableMasonry2ForCampaignOverview: false,
  };

  useEffect(() => {
    const value = localStorage.getItem('enableProgramOverviewMasonry2');
    setIsLocallyEnabled(value === 'true');
  }, []);

  const serverDrivenConfig = useConfigSelection(
    (config) =>
      isConfigSettled(config)
        ? {
            enableMasonry2ForCampaignOverview:
              config.config
                .release_journey_experience_masonry_2_for_campaign_overview,
          }
        : {},
    defaultServerConfig,
  );

  return (
    serverDrivenConfig.enableMasonry2ForCampaignOverview ||
    (isLocallyEnabled && !isProduction())
  );
}

export const ChallengeRoutes = (): JSX.Element => {
  const isMasonryCampaignOverviewEnabled = useEnableProgramOverviewMasonry();

  const [urlSearchParams] = useSearchParams();

  const isSoloChallenge = urlSearchParams.get('type') === 'solo';

  return (
    <Routes>
      <Route
        path=":challengeId"
        element={
          isMasonryCampaignOverviewEnabled && isSoloChallenge ? (
            <ProgramOverviewRedirect />
          ) : (
            <ChallengeLandingPage />
          )
        }
      />
      <Route path=":challengeId/settings/*" element={<SettingsPage />} />
      <Route path=":challengeId/join-team/*" element={<JoinTeamPage />} />
      <Route path=":challengeId/team/:teamId/*" element={<TeamLandingPage />} />
      <Route
        path=":challengeId/activities/completed/*"
        element={<ChallengeActivitiesHistoryPage activityStatus="completed" />}
      />
      <Route
        path=":challengeId/activities/missed/*"
        element={<ChallengeActivitiesHistoryPage activityStatus="missed" />}
      />
    </Routes>
  );
};
